import api from '../index'

export default {
    modifyUserInfo(params) { // 新增用户修改记录
        return api.post('/modifyData/user', params)
    },

    getUserInfoChangeList(params) { // 获取用户修改记录的列表
        return api.get('/modifyData/user/list', params)
    }
}
